import React from 'react'
import { GetServerSideProps } from 'next'
import Head from 'next/head'

import { API } from '../../../../revelry_api'
import FourOFour from '../../../../components/pages/FourOFour'
import { FuneralHome, LifePageNavItem, MemorialTree, ObituarySnippet } from '../../../../types'
import { FuneralHomeFooter } from '../../../../components/FuneralHomeFooter'
import LifePageLayout from '../../../../components/LifePageLayout'
import MemorialTreesPage from '../../../../components/pages/MemorialTreesPage'
import Obituary from '../../../../components/models/Obituary'

interface Props {
  funeralHome: FuneralHome | null
  memorialTrees: MemorialTree[]
  obituary: ObituarySnippet | null
}

const MemorialTrees: React.FC<Props> = ({ funeralHome, memorialTrees, obituary }) => {
  if (!obituary || !funeralHome) {
    return <FourOFour />
  }

  return (
    <>
      <Head>
        <title>Plant memorial trees in memory of {Obituary.deceasedFullName(obituary)}</title>

        <meta name="robots" content="noindex" />

        <meta
          name="description"
          content={`Plant memorial trees in memory of ${Obituary.deceasedFullName(
            obituary,
          )}. Honor a lost loved one with a meaningful gift that will last for years to come.`}
          key="description"
        />
      </Head>

      <LifePageLayout activeNavItem={LifePageNavItem.MEMORIAL_TREES} obituary={obituary}>
        <MemorialTreesPage memorialTrees={memorialTrees} obituary={obituary} />
      </LifePageLayout>

      <FuneralHomeFooter />
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async (req) => {
  try {
    const slugArray = (req.params.slug as string).split('-')
    const obituaryID = slugArray[slugArray.length - 1]
    const [funeralHome, obituary, memorialTrees] = await Promise.all([
      API.funeralHomes.load(),
      API.obituaries.load(obituaryID),
      API.flowerstore.loadMemorialTrees(),
    ])

    return { props: { funeralHome, memorialTrees, obituary } }
  } catch (e) {
    return { props: { funeralHome: null, memorialTrees: [], obituary: null } }
  }
}

export default MemorialTrees
